import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { Router } from '@angular/router';

export interface Token {
  'access_token': string;
  'refresh_token': string;
  'client_secret': string;
  'token_type'?: string;
  'expires_in'?: number;
  'client_id'?: string;
}
@Injectable()
export class AccessTokenService {
  public siteTokenKey;
  constructor(private storageService: StorageService, private _router: Router) {
    this.siteTokenKey = '_apiTokenAccessSessionID_';
  }

  getAccessToken(): string {
    if (this.storageService.getLocalStorage(this.siteTokenKey)) {
      return this.storageService.getLocalStorage(this.siteTokenKey);
    }
    return '';
  }

  getTokenDetails(redirect = true): any {
    if (!!this.storageService.getLocalStorage(this.siteTokenKey)) {
      return this.storageService.getLocalStorage(this.siteTokenKey);
    } else {
      // No token details present so need to redierct login
      // location.href = '/api/login/dist/index.html';
      if (redirect) {
        this._router.navigate(['home']);
      } else {
        return false;
      }
    }
  }

  setTokenDetails(token: any) {
    this.storageService.setLocalStorage(this.siteTokenKey, token);
  }

  destroyToken() {
    this.storageService.removeLocalStorage(this.siteTokenKey);
    this.storageService.clearSessionStorage();
  }

}
